import {DESVIO,BUZON,OCULTACION} from "@/constants/general-managment-constants"

const TIPO_SERVICIO = {
  PERDIDAS: "perdidas",
  BUZON: BUZON,
  OCULTACION: OCULTACION,
  DESVIO: DESVIO,
};
const NAME_SERVICIO = {
  perdidas_true: "Llamadas perdidas activado",
  perdidas_false: "Llamadas perdidas desactivado",
  buzon_true: "Buzón de voz activado",
  buzon_false: "Buzón de voz desactivado",
  ocultacion: "Ocultación de identidad activada",
  desvio: "Hay desvíos de llamadas activos",
};
export const getActiveConfigs = ({ configs, tipoServicio }) => {
  let objResponse = {};
  switch (tipoServicio) {
    //caso de perdidas o buzon
    case TIPO_SERVICIO.BUZON:
    case TIPO_SERVICIO.PERDIDAS:
      if (configs && Array.isArray(configs) && configs.length > 0) {
        if (configs && Array.isArray(configs) && configs.length > 0) {
          configs = configs.filter((x) => x.activacion === true);
          let serviceConfig = {};

          if (configs && Array.isArray(configs) && configs.length > 0) {
            serviceConfig[`${tipoServicio}_true`] = {
              idRestriccion: `${`${tipoServicio}_true`}`,
              name: NAME_SERVICIO[`${tipoServicio}_true`],
              estado: true,
            };
            objResponse = { ...serviceConfig };
          } else {
            serviceConfig[`${tipoServicio}_false`] = {
              idRestriccion: `${`${tipoServicio}_false`}`,
              name: NAME_SERVICIO[`${tipoServicio}_false`],
              estado: false,
            };
            objResponse = { ...serviceConfig };
          }
        }
      }
      return objResponse;
    case TIPO_SERVICIO.OCULTACION:
    case TIPO_SERVICIO.DESVIO:
      let activeConfigs = {};
      if (configs && Array.isArray(configs) && configs.length > 0) {
        configs = configs.filter((x) => x.activacion === true);

        configs.map(
          (x) =>
            (activeConfigs[`${x.tipo_desvio}_${x.tipo_servicio}`] = {
              idRestriccion: `${x.tipo_desvio}_${x.tipo_servicio}`,
              name: x.nombre,
              estado: x.activacion,
              tipo_servicio: x.tipo_servicio,
            })
        );
        if (activeConfigs && Object.keys(activeConfigs).length > 0) {
          let serviceConfig = {};
          serviceConfig[tipoServicio] = {
            idRestriccion: `${tipoServicio}`,
            name: NAME_SERVICIO[tipoServicio],
            estado: true,
          };
          objResponse = { ...serviceConfig };
        }
      }
      return objResponse;
    default:
      return null;
  }
};
